<template functional>
  <v-card style="margin:0 0 4px 4px;">
    <v-img
      v-lazy:background-image=props.post.imageurl
      aspect-ratio=0.9
      class="reviewCard"
    ></v-img>
  </v-card>
</template>

<script>

export default {
  name: 'ReviewCardImage',
  props: {
    post: Object
  }
}
</script>

<style scoped>
  .reviewCard[lazy='loaded'] {
    background-size: cover;
  }
</style>